import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Button from '../Button';
import { handleActive } from '../../utils/handleActive';

import ImageLogoNooioColored from '../../assets/logo-nooio-colored.svg';
import IconProductNooioSearch from '../../assets/icon-product-nooio-search.svg';
import IconProductNooioMinisites from '../../assets/icon-product-nooio-minisites.svg';
import IconProductNooioFoodmarket from '../../assets/icon-product-nooio-foodmarket.svg';
import IconProductNooioAds from '../../assets/icon-product-nooio-ads.svg';
import IconProductNooioSmartClick from '../../assets/icon-product-nooio-smartclick.svg';
import IconProductNooioBlog from '../../assets/icon-product-nooio-blog.svg';

import { HeaderContainer } from './styles';

interface HeaderProps {
  page?: 'home' | 'about' | 'products' | 'support' | '';
}

function Header({ page = '' }: HeaderProps) {

  useEffect(handleDropdown, []);

  useEffect(() => {
    if (window.innerWidth <= 540) {
      Array.from(document.querySelectorAll('#navigation a')).forEach(
        link => link.addEventListener('click', () => handleActive(['#toggle', '#navigation', 'body'], 'remove'))
      );
    }
  }, []);

  function handleDropdown() {
    const dropdownKittenList = Array.from(document.querySelectorAll('.js-dropdown-kitten'));

    dropdownKittenList.forEach( dropdownKitten => {
        dropdownKitten.addEventListener('mouseenter', (e: any) => {
          const dropdownSelector = e.target.getAttribute('data-dropdown-selector');

          handleActive(['#menu-dropdown', `.${dropdownSelector}`], 'add');
        });

        dropdownKitten.addEventListener('mouseover', (e: any) => {
            const dropdownSelector = e.target.getAttribute('data-dropdown-selector');

            handleActive(['#menu-dropdown', `.${dropdownSelector}`], 'add');
        });

        dropdownKitten.addEventListener('mouseout', (e: any) => {
            const dropdownSelector = e.target.getAttribute('data-dropdown-selector');

            handleActive(['#menu-dropdown', `.${dropdownSelector}`], 'remove');
        });
    })
  };

  return (
    <HeaderContainer>
      <div className="bar-top">
        <div className="content">
          <span>
            Tire as suas dúvidas:
            <strong>
              <a href="tel:0800 65 99669-2981"> 0800 65 99669-2981</a>
            </strong>
          </span>

          <div className="social">
            <a href="#facebook">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#linkedin">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="#YouTube">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="content">
        <a href="/" className="logo">
          <img src={ImageLogoNooioColored} alt="Nooio" />
        </a>

        <nav id="navigation">
          <ul>
            <li>
              <Link to="/" className={`${page === 'home' && 'active'}`}>
                Início
              </Link>
            </li>

            <li>
              <Link
                to="/products"
                className={`js-dropdown-kitten ${
                  page === 'products' && 'active'
                }`}
                data-dropdown-selector="products"
              >
                Produtos
                <i className="far fa-chevron-down"></i>
              </Link>
            </li>

            <li>
              <Link to="/about" className={`${page === 'about' && 'active'}`}>
                Sobre o Nooio
              </Link>
            </li>

            <li>
              <Link
                to="/support"
                className={`${page === 'support' && 'active'}`}
              >
                Suporte
              </Link>
            </li>

            <div className="buttons-m to-mobile">
              <Button go="/register" outline>Cadastre-se</Button>

              <Button go="/login" >Entrar</Button>
            </div>
          </ul>
        </nav>

        <div className="buttons to-desktop">
          <Button go="/register" outline>Cadastre-se</Button>

          <Button go="/login" >Entrar</Button>
        </div>

        <div
          id="toggle"
          className="to-mobile"
          onClick={() => handleActive(['#toggle', '#navigation', 'body'])}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="menu-dropdown">
        <div className="wrapper">
          <div
            className="dropdown-content products js-dropdown-kitten"
            data-dropdown-selector="products"
          >
            <div className="content">
              <h3>Produtos</h3>
              <h2>Conheça os nossos produtos e serviços:</h2>

              <div className="grid-products">
                <a
                  href="https://search.nooio.com.br"
                  target="_blank"
                  className="product"
                  rel="noreferrer"
                >
                  <img
                    src={IconProductNooioSearch}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>Nooio Search</strong>
                    <span>Sistema de busca de restaurantes</span>
                  </div>
                </a>

                <a
                  href="http://minisite.delivery/"
                  target="_blank"
                  className="product"
                  rel="noreferrer"
                >
                  <img
                    src={IconProductNooioMinisites}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>Minisites</strong>
                    <span>Mini lojas de delivery prontas</span>
                  </div>
                </a>

                <a
                  href="https://foodmarket.nooio.com.br"
                  target="_blank"
                  className="product"
                  rel="noreferrer"
                >
                  <img
                    src={IconProductNooioFoodmarket}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>FoodMarket</strong>
                    <span>Marketplace de promoções e delivery</span>
                  </div>
                </a>

                <a
                  href="#dawwf"
                  target="_blank"
                  rel="noreferrer"
                  className="product"
                >
                  <img
                    src={IconProductNooioAds}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>Nooio Ads</strong>
                    <span>
                      Aumente seu tráfego com anúncios em nossos sites
                    </span>
                  </div>
                </a>

                <a
                  href="#fwfw"
                  target="_blank"
                  rel="noreferrer"
                  className="product"
                >
                  <img
                    src={IconProductNooioSmartClick}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>SmartClick</strong>
                    <span>Marketing para atrair clientes no seu Minisite</span>
                  </div>
                </a>

                <a
                  href="#fdw"
                  target="_blank"
                  className="product"
                  rel="noreferrer"
                >
                  <img
                    src={IconProductNooioBlog}
                    alt="Product Nooio"
                  />

                  <div className="text">
                    <strong>Nooio Blog</strong>
                    <span>Notícias, dicas, tutoriais e muito mais</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeaderContainer>
  );
}

export default Header;
